<script>
  import { onMount } from 'svelte';
  import padStart from 'lodash/padStart';
  import forEach from 'lodash/forEach';
  import Eclipse from '../../Helper/Eclipse.svelte';
  import { TIME } from '../../stores.js';
  import { NOTE_FADE_IN_TIME, NOTE_FADE_OUT_TIME } from '../../config.js'
  import { secondsToMin, between, isBetween, titleClickToStart } from '../../utils.js'
  export let startTime;
  export let text;
  export let images = [];
  export let captions = [];
  export let index;
  export let isChapterTitle = false;
  export let isActive = false;

  let note;
  let finalHeight;

  $: style = `height: ${isActive ? finalHeight : 40}px;` // 40px is the default height => two lines visible

  $: imageStyle = `height: ${35 / images.length + 1}vh; width: auto;`

  onMount (() => {
    let height = 0;
    const elements = [...note.getElementsByTagName('img'), ...note.getElementsByTagName('figcaption'), ...note.getElementsByTagName('p')]
    forEach(elements, (el) => {
      height += el.scrollHeight
    })
    height += images.length * 10 // We add the bottom-margin of the images
    finalHeight = Math.max(height, note.scrollHeight) + 20 // These 20px are the same as we defining in the layout-sidebar-chapter.scss
  })

  function goToSecond (v) { window.goToSecond(v); }
</script>

<div
  bind:this={note}
  class="note"
  class:isChapterTitle={isChapterTitle}
  class:isActive={isActive}
  on:click={() => isChapterTitle ? false : goToSecond(startTime)}
  title={isChapterTitle ? '' : titleClickToStart(startTime)}>
  {#if isChapterTitle}
  <Eclipse i="chapterTitle" />
  <span class="note-chapter-number clickable" on:click={() => goToSecond(startTime)} title={titleClickToStart(startTime)}>{ padStart(index, 2, '0') }</span>
  {:else}
  <Eclipse i={index + 1} />
  <time class="note-time">{ secondsToMin(startTime) }</time>
  {/if}
  {#if images.length && captions.length}
    <figure class="note-image" style={style}>
      {#if captions.length > 1}
      {#each captions as caption, i}
      <img src={`./img/${images[i]}`} style={imageStyle} alt={ caption } />
      <figcaption class="note-caption">{ @html caption }</figcaption>
      {/each}
      {:else}
      {#each images as image}
      <img src={`./img/${image}`} style={imageStyle} alt={ captions[0] } />
      {/each}
      <figcaption class="note-caption">{ @html captions[0] }</figcaption>
      {/if}
    </figure>
  {:else}
    {#if isChapterTitle}
    <p class="note-text clickable" on:click={() => goToSecond(startTime)} title={titleClickToStart(startTime)} style={style}>{ @html text }</p>
    {:else}
    <p class="note-text" style={style}>{ @html text }</p>
    {/if}
  {/if}
</div>
